import { FollowUpStatus } from "src/types";

export const getFollowUpStatusLabel = (
  status: FollowUpStatus | undefined,
): string => {
  switch (status) {
    case "ready":
      return "Ready";
    case "initiated":
      return "Initiated";
    case "needs_host":
      return "Needs Host";
    case "needs_template":
      return "Needs Template";
    default:
      return "None";
  }
};

export const getFollowUpStatusBackgroundColor = (
  status: FollowUpStatus | undefined,
): string => {
  switch (status) {
    case "ready":
      return "#7aa6ea";
    case "initiated":
      return "#a8d5ba";
    case "needs_host":
    case "needs_template":
      return "#ef4444";
    default:
      return "#d1d5db";
  }
};
